import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

declare const ga: Function;
declare global {
  interface Window {
    gtag: Function;
    dataLayer: any[];
  }
}

const GLS_COOKIE_POLICY = 'gls-cookie-policy';
const APP_NAME = "YourGLS Authenticate";
export class EventOptions {
  category: string;
  label: string;
  action: string;
  nonInteraction: boolean;
  page?: string;
  fn?: Function;
  transport?: string;

  constructor(
    category: string,
    label: string,
    action: string,
    nonInteraction: boolean = false,
    page?: string,
    fn?: Function,
    transport?: string
  ) {
    this.category = category;
    this.label = label;
    this.action = action;
    this.page = page;
    this.nonInteraction = nonInteraction;
    this.fn = fn;
    this.transport = transport;
  }
}

export class EventOptionsBuilder {
  private eventOptions: EventOptions;

  constructor(
    options: EventOptions = {
      category: '',
      action: '',
      label: '',
      nonInteraction: true,
    }
  ) {
    this.eventOptions = new EventOptions(
      options.category,
      options.label,
      options.action,
      options.nonInteraction
    );
  }

  setCategory(category: string) {
    this.eventOptions.category = category;
    return this;
  }

  setLabel(label: string) {
    this.eventOptions.label = label;
    return this;
  }

  setAction(action: string) {
    this.eventOptions.action = action;
    return this;
  }

  setPage(page: string) {
    this.eventOptions.page = page;
    return this;
  }

  setNonInteraction(nonInteraction: boolean) {
    this.eventOptions.nonInteraction = nonInteraction;
    return this;
  }

  setCallback(callback: Function) {
    this.eventOptions.fn = callback;
    return this;
  }

  setBeacon() {
    this.eventOptions.transport = "Beacon";
    return this;
  }

  removeBeacon() {
    this.eventOptions.transport = undefined;
    return this;
  }
  getResult() {
    return this.eventOptions;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private cookieService: CookieService) {}

  initialize(ga4TrackingId: string, tagManagerId: string) {
    if (!this.isEnabled()) {
      return;
    }

    if(tagManagerId) {
      const script = document.createElement('script');
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${tagManagerId}');`;
      document.head.appendChild(script);
    }

    if (ga4TrackingId) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() { window.dataLayer.push(arguments);}
      const gtag = window.gtag;
      gtag('js', new Date());
      gtag('config', ga4TrackingId, { 'send_page_view': false, 'cookie_expires': (60 * 60 * 24 * 30 * 13)});
      gtag('set', { 'send_page_view': false, 'cookie_expires': (60 * 60 * 24 * 30 * 13)});
    }
  }

  sendPageView(title: string, page: string, fn?: Function) {
    if (!this.isEnabled()) {
      return;
    }

    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: title,
        page_path: page,
        screen_name: title,
        page_location: window.location,
        app_name: APP_NAME,
        event_callback: fn
      });
    }
  }

  sendEvent(eventOptions: EventOptions) {
    const { category, label, action, page, nonInteraction, fn, transport } = eventOptions;

    if (!this.isEnabled()) {
      return;
    }

    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        page_path: page,
        event_action: action,
        app_name: APP_NAME,
        non_interaction: Boolean(nonInteraction),

      })
    }
  }

  isEnabled(): boolean {
    const isCookiePresent = this.cookieService.check(GLS_COOKIE_POLICY);
    if (isCookiePresent) {
      const glsCookiePolicy = this.cookieService.get(GLS_COOKIE_POLICY);
      return glsCookiePolicy == 'accepted';
    }

    return isCookiePresent;
  }
}
